<template>
  <div class="chart-gauge" :id="nombre" @click="navegar"></div>
</template>


<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "gaugetermometro",
  data: function() {
    return {
      range0: null,
      label: null,
      vinculo: "",
      filtro: "",
      Contenido: "",
      hand: ""
    };
  },
  watch: {
    valores: function() {
      let datos = this.$store.getters[this.fuente];
      let dato = datos.filter(record => {
        return record[this.filtro] === this.id;
      })[0];
      this.range0.endValue = dato.avance;
      this.hand.value = dato.avance;
      this.label.text =
        Intl.NumberFormat("es-CO", { minimumFractionDigits: 1 }).format(
          dato.avance
        ) + " %";
      if (this.filtro == "idpilar") {
        this.Contenido.text =
          "(" +
          dato.estrategias +
          " Estrategias - " +
          dato.indicadores +
          " Indicadores)";
      }
      if (this.filtro == "idestrategia") {
        this.Contenido.text =
          "(" + dato.lineas + " Lineas - " + dato.indicadores + " Indicadores)";
      }
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    nombre: {
      type: String,
      required: true
    },
    fuente: {
      type: String
    }
  },
  methods: {
    navegar() {
      this.$router.push({
        path: this.vinculo
      });
    }
  },
  mounted() {
    if (this.fuente === "gpuntos") {
      this.filtro = "idpunto";
      if (this.vinculo !== "#") {
        this.vinculo = "/pilar/" + this.id;
      }
    }
    if (this.fuente === "gpilares") {
      this.filtro = "idpilar";
    }
    if (this.fuente === "gestrategias") {
      this.filtro = "idestrategia";
      this.vinculo = "";
    }
    if (this.fuente === "gpilarescat") {
      this.filtro = "idpilar";
      this.vinculo = "";
    }       
    let datos = this.$store.getters[this.fuente];
    let dato = datos.filter(record => {
      return record[this.filtro] === this.id;
    })[0];
    if (this.fuente === "gpilares") {
      this.vinculo = "/estrategia/" + dato.idpunto + "/" + this.id;
    }
    // create chart
    var chart = am4core.create(this.nombre, am4charts.GaugeChart);

    chart.width = 300;
    chart.height = 300;
    chart.innerRadius = am4core.percent(90);
    chart.startAngle = -190;
    chart.endAngle = 10;

    /**
     * datos basicos para la grafica
     */
    var axis = chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.renderer.radius = am4core.percent(90);
    axis.renderer.labels.template.fontSize = 10;

    //  creamos una sombra para darle efecto a la grafica.
    let shadow = axis.filters.push(new am4core.DropShadowFilter());
    shadow.dx = 1;
    shadow.dy = 1;
    shadow.blur = 2;
    shadow.opacity = 0.5;

    /**
     * contiene los 2 rangos el de color que indica el valor y el gris que indica el valor restante
     */
    let rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(-0.1, -0.1, -0.1, 0, -0.9);

    var fillModifier = new am4core.LinearGradientModifier();
    fillModifier.radius = true;
    fillModifier.brightnesses = [0, 0, 0, 0];
    fillModifier.offsets = [0, 0.45, 0.55, 1];

    this.range0 = axis.axisRanges.create();
    this.range0.value = 0;
    this.range0.endValue = dato.avance;
    this.range0.axisFill.fillOpacity = 1;
    this.range0.axisFill.fill = am4core.color(dato.color);
    this.range0.axisFill.fillModifier = fillModifier;
    this.range0.axisFill.zIndex = -1;

    var range1 = axis.axisRanges.create();
    range1.value = 0;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color("#ededed");
    range1.axisFill.zIndex = -2;

    /**
     * contiene el Texto inteno de la grafica, da el procentaje
     */

    this.label = chart.radarContainer.createChild(am4core.Label);
    this.label.isMeasured = false;
    this.label.fontSize = 20;
    this.label.horizontalCenter = "middle";
    this.label.verticalCenter = "bottom";
    this.label.fill = am4core.color(dato.color);
    this.label.text =
      Intl.NumberFormat("es-CO", { minimumFractionDigits: 1 }).format(
        dato.avance
      ) + " %";
    this.label.y = 30;

    var Title = chart.radarContainer.createChild(am4core.Label);
    Title.isMeasured = false;
    Title.fontSize = 16;
    Title.horizontalCenter = "middle";
    Title.text = dato.nombrecompleto;
    Title.wrap = true;
    Title.maxWidth = 280;
    Title.truncate = true;
    Title.y = 35;
    Title.tooltipText = dato.nombrecompleto;
    Title.tooltip.pointerOrientation = "vertical";
    Title.tooltip.label.maxWidth = 300;
    Title.tooltip.label.wrap = true;
    Title.tooltip.label.textAlign = "justify";
    Title.tooltip.background.cornerRadius = 10;
    Title.tooltip.getFillFromObject = false;
    Title.tooltip.background.fill = am4core.color("#4866c8");

    this.Contenido = chart.radarContainer.createChild(am4core.Label);
    this.Contenido.isMeasured = false;
    this.Contenido.fontSize = 14;
    this.Contenido.horizontalCenter = "middle";
    this.Contenido.y = 55;

    if (this.filtro == "idpilar") {
      this.Contenido.text =
        "(" +
        dato.estrategias +
        " Estrategias - " +
        dato.indicadores +
        " Indicadores)";
    }
    if (this.filtro == "idestrategia") {
      this.Contenido.text =
        "(" + dato.lineas + " Lineas - " + dato.indicadores + " Indicadores)";
    }
    if (this.filtro != "idpunto") {
      this.hand = chart.hands.push(new am4charts.ClockHand());
      this.hand.axis = axis;
      this.hand.innerRadius = am4core.percent(30);
      this.hand.startWidth = 10;
      this.hand.pin.disabled = true;
      this.hand.value = 0;
      var GetHand = this.hand;
      var value = dato.avance;

      /**
       * Creamos la animacion de las manecillas
       */

      var animation = new am4core.Animation(
        GetHand,
        {
          property: "value",
          to: value
        },
        100,
        am4core.ease.cubicOut
      );
      animation.start();
    }

    this.chart = chart;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  computed: {
    valores() {
      return this.$store.getters[this.fuente];
    }
  }
};
</script>

<style scoped>
.chart-gauge {
  width: 100%;
  height: 290px;
}
</style>